import React, { createContext, useContext } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // 既存仕様：localStorage の user を正とする
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const value = {
    user,
    userId: user?.id ?? null,
    role: user?.role ?? 'staff', // admin / manager / staff
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
